import React, { useEffect, useRef, useState } from "react";
import { Sparkles } from "lucide-react";
import api from "@/lib/api";

const SCHOOL_IMG = "https://customer-assets-7cd3h4nn.emergentagent.net/job_dorm-attendance-4/artifacts/wz7p0qxp_IMG_20260927_140020.png";
const LOGO = "https://customer-assets-7cd3h4nn.emergentagent.net/job_dorm-attendance-4/artifacts/c3wpw9lm_images%20%288%29.jpeg";

function getSeasonalBanner(d) {
  const m = d.getMonth();
  const day = d.getDate();
  if (m === 11 || (m === 10 && day >= 21)) return "Cuti Akhir Tahun — Selamat bercuti, warga asrama!";
  if (m === 0 && day <= 15) return "Tahun Baharu — Selamat kembali ke asrama!";
  if ((m === 4 && day >= 20) || (m === 5 && day <= 15)) return "Minggu Peperiksaan Pertengahan Tahun — Semoga berjaya!";
  if (m === 9) return "Minggu Peperiksaan Akhir Tahun — Semoga berjaya!";
  return null;
}

export default function WelcomeSplash({ onDone }) {
  const [phase, setPhase] = useState(0);
  const [leaving, setLeaving] = useState(false);
  const onDoneRef = useRef(onDone);
  onDoneRef.current = onDone;
  const [seasonal, setSeasonal] = useState(null);

  useEffect(() => {
    let active = true;
    api.get("/seasonal-banner")
      .then((response) => {
        if (!active) return;
        setSeasonal(response.data?.message?.trim() || getSeasonalBanner(new Date()));
      })
      .catch(() => {
        if (active) setSeasonal(getSeasonalBanner(new Date()));
      });
    return () => { active = false; };
  }, []);

  const skip = () => {
    setLeaving(true);
    setTimeout(() => onDoneRef.current && onDoneRef.current(), 350);
  };

  useEffect(() => {
    const timers = [
      setTimeout(() => setPhase(1), 400),
      setTimeout(() => setPhase(2), 1300),
      setTimeout(() => setLeaving(true), 4500),
      setTimeout(() => onDoneRef.current && onDoneRef.current(), 5000),
    ];
    return () => timers.forEach(clearTimeout);
  }, []);

  return (
    <div
      data-testid="welcome-splash"
      onClick={skip}
      role="button"
      tabIndex={0}
      aria-label="Ketik untuk teruskan ke log masuk"
      className="relative flex min-h-screen w-full cursor-pointer items-center justify-center overflow-hidden px-6 text-center"
      style={{
        backgroundImage: `linear-gradient(rgba(11,17,32,0.5), rgba(11,17,32,0.72)), url(${SCHOOL_IMG})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        opacity: leaving ? 0 : 1,
        transition: "opacity 0.5s ease",
      }}
    >
      <div>
        {phase >= 1 && (
          <div className="animate-fade-up mx-auto mb-8 h-28 w-28 rounded-full bg-white p-1.5 shadow-2xl ring-4 ring-white/25">
            <img src={LOGO} alt="Logo SMKMI" className="h-full w-full rounded-full object-cover" />
          </div>
        )}

        {phase >= 2 && (
          <div data-testid="splash-welcome-content" className="animate-fade-up">
            <p className="uppercase sm:text-base" style={{ color: "#FACC15", fontWeight: 800, letterSpacing: 6, marginBottom: 14, fontSize: 14 }}>
              Selamat Datang
            </p>
            <h1
              data-testid="splash-welcome-text"
              className="font-display font-extrabold leading-tight text-white"
              style={{ fontSize: "clamp(2rem, 5vw, 3.4rem)", textShadow: "0 2px 20px rgba(0,0,0,0.85)", maxWidth: "52rem", marginInline: "auto" }}
            >
              Selamat Datang ke{" "}
              <span style={{ color: "#FACC15" }}>Penginapan Atlet Cemerlang SSN Penang</span>
            </h1>
            <div className="mx-auto mt-9 rounded-full bg-[#FACC15]" style={{ width: 128, height: 6, boxShadow: "0 0 20px rgba(250,204,21,0.6)" }} />

            {seasonal && (
              <div
                data-testid="seasonal-banner"
                className="mx-auto mt-7 inline-flex items-center gap-2 rounded-full border border-[#FACC15]/40 bg-[#FACC15]/15 px-4 py-2 text-xs font-semibold text-[#FEF3C7] sm:text-sm"
              >
                <Sparkles className="h-4 w-4 text-[#FACC15]" />
                {seasonal}
              </div>
            )}

            <p data-testid="skip-hint" className="mt-8 text-xs text-white/70">Ketik di mana-mana untuk teruskan &rarr;</p>
          </div>
        )}
      </div>
    </div>
  );
}
